import React, { createContext } from "react";
import {
  IRouterContext,
  IRouterContextData,
} from "../type/contextType/routerContext";

// Routerオブジェクトを作成する
export const TkRouteContext = createContext<{
  state: IRouterContextData;
  setState: (state: IRouterContextData) => void;
}>({
  state: {},
  setState: (state: IRouterContextData) => {},
});

// Providerコンポーネントを作成し、子コンポーネントにContextデータを提供する
export const TkRouteContextProvider: React.FC<IRouterContext> = (props) => {
  const [state, setState] = React.useState<IRouterContextData>({});

  return (
    <TkRouteContext.Provider value={{ state, setState }}>
      {props.children}
    </TkRouteContext.Provider>
  );
};

export default TkRouteContextProvider;
